import { createContext, useContext, useEffect, useState, type ReactNode } from "react";

export type Lang = "en" | "es";

type Dict = Record<string, string>;

const en: Dict = {
  // Announcement bar
  "banner.construction": "NOW UNDER CONSTRUCTION",
  "banner.starting": "RESIDENCES STARTING AT $4M",
  "banner.sold": "NOW 75% SOLD",

  // Nav
  "nav.north": "North Tower",
  "nav.south": "South Tower",
  "nav.floorplans": "Floor Plans",
  "nav.gallery": "Gallery",
  "nav.location": "Location",
  "nav.request": "Request Information",

  // Hero
  "hero.eyebrow": "Brickell Key · Miami",
  "hero.schedule": "Schedule Presentation",
  "hero.requestPriceList": "Request Price List",
  "hero.scroll": "Scroll",

  // Intro
  "intro.eyebrow": "500 Brickell Key Drive",
  "intro.title": "An island address, moments from the heart of Miami.",
  "intro.body":
    "Set on the southern tip of Brickell Key, The Residences at Mandarin Oriental, Miami comprise two architectural towers connected by lush gardens, a private marina, and a full-service hotel. A sanctuary of calm, a stage for the city.",

  // Condos for Sale
  "condos.title": "CONDOS FOR SALE",
  "condos.address": "888 Brickell Ave, Miami, FL 33131",
  "condos.beds": "Bed(s)",
  "condos.baths": "Bath(s)",
  "condos.prev": "Previous",
  "condos.next": "Next",


  // North Tower
  "north.eyebrow": "North Tower",
  "north.title": "Elevated island living, reimagined.",
  "north.body":
    "Rising 33 stories above the southernmost tip of Brickell Key, the North Tower introduces an exclusive collection of just 70 Private Residences alongside the new Mandarin Oriental, Miami Hotel. Panoramic views of Biscayne Bay, the Atlantic Ocean, and the Miami skyline are complemented by world-class amenities, legendary Mandarin Oriental service, and an exceptional waterfront lifestyle.",
  "north.stat.stories": "Stories",
  "north.stat.residences": "Private Residences",
  "north.stat.starting": "Starting from",

  // South Tower
  "south.eyebrow": "South Tower",
  "south.title": "Iconic waterfront luxury, elevated.",
  "south.body":
    "Rising 66 stories above the southernmost tip of Brickell Key, the South Tower is an architectural landmark featuring 228 luxury branded residences. Designed by Kohn Pedersen Fox (KPF) with interiors by Tristan Auer, each residence showcases expansive floor-to-ceiling glass, 12-foot-deep private terraces, natural stone flooring, custom Italian cabinetry, and soaring 11-foot ceilings. Combined with legendary Mandarin Oriental service, world-class amenities, and breathtaking views of Biscayne Bay and the Miami skyline, the South Tower delivers an unparalleled waterfront lifestyle.",
  "south.stat.stories": "Stories",
  "south.stat.residences": "Luxury Residences",
  "south.stat.starting": "Starting from",

  // Downloads
  "downloads.eyebrow": "2030 Delivery",
  "downloads.title1": "Starting From",
  "downloads.title2": "$4 Million",
  "downloads.brochure": "Download Brochure",
  "downloads.factSheet": "Download Fact Sheet",
  "downloads.floorPlans": "Download Floor Plans",
  "downloads.renderings": "Download Renderings",

  // Location
  "location.eyebrow": "Location",
  "location.title": "500 Brickell Key Drive, Miami.",
  "location.body":
    "A six-minute drive to the Financial District. Twelve minutes to Miami International Airport. A lifetime away from everywhere else.",

  // Gallery
  "gallery.eyebrow": "GALLERY",
  "gallery.title": "Mandarin Gallery",

  // Contact Section
  "contact.eyebrow": "Inquire",
  "contact.title": "Request the private price list.",
  "contact.body":
    "Complete the form and a member of our sales team will be in touch within one business day.",

  // Request Modal
  "modal.title": "Request Information",
  "modal.subtitle": "Please fill the form below and we'll contact you shortly.",
  "modal.rolePlaceholder": "Are you a buyer or real estate agent? *",
  "modal.buyer": "Buyer",
  "modal.agent": "Real estate agent",
  "modal.firstName": "First Name *",
  "modal.lastName": "Last Name *",
  "modal.email": "Email *",
  "modal.phone": "Phone Number *",
  "modal.comments": "Comments",
  "modal.timeframe": "Estimated purchase timeframe",
  "modal.timeframe.placeholder": "Estimated purchase timeframe",
  "modal.timeframe.1": "Within 1 month",
  "modal.timeframe.2": "2-3 months",
  "modal.timeframe.3": "3-6 months",
  "modal.timeframe.4": "6+ months",

  "modal.consent":
    "I consent to being contacted by Zaga Team | Mandarin Oriental Miami via call, email, or text for real estate services. You may opt out at any time by replying 'stop' or 'help' for assistance. You can also click the unsubscribe link in emails. Standard message and data rates may apply. Message frequency may vary. Privacy Policy and Terms of Service.",
  "modal.required": "* Required Fields",
  "modal.submit": "Submit",
  "modal.thankYou": "Thank You",
  "modal.thankYouBody": "We will be in touch shortly.",
  "modal.close": "Close",

  // Agent notice
  "agent.notice": "Notice",
  "agent.title": "Buyers Only",
  "agent.body1":
    "Unfortunately, we do not work with real estate agents. However, if you have a specific request, please feel free to call us at ",
  "agent.close": "Close",

  // Footer
  "footer.eyebrow": "Inquire",
  "footer.title": "Request Prices & Availability",
  "footer.body":
    "For detailed information, prices and availability, please fill the form; our team will contact you with the latest information from this development.",
  "footer.deposit": "Deposit Schedule",
  "footer.deposit1": "20% at Contract",
  "footer.deposit2": "20% at Groundbreaking",
  "footer.deposit3": "10% at Amenity Deck",
  "footer.deposit4": "50% at Closing",
  "footer.salesAddress": "Sales Gallery Address",
  "footer.contactInfo": "Contact Information",
  "footer.rolePlaceholder": "Are you buyer or real estate agent? *",
  "footer.agent": "Real Estate Agent",
  "footer.commentsPlaceholder": "I am interested in The Residences at Mandarin Oriental, Miami",
  "footer.consent":
    "I agree to be contacted by Zaga Team | Mandarin Oriental Miami via call, email, and text for real estate services. Reply 'stop' to opt out.",
  "footer.required": "* Required fields",
  "footer.submit": "REQUEST INFORMATION",
  "footer.legal":
    "Zaga team is a real estate advisory team affiliated with Luxury International Realty LLC. Luxury International Realty LLC is a licensed real estate broker and abides by equal housing opportunity laws. All material presented herein is intended for informational purposes only. Information is compiled from sources deemed reliable but is subject to errors, omissions, changes in price, condition, sale, or withdrawal without notice. No statement is made as to accuracy of any description. All measurements and square footages are approximate. This is not intended to solicit properties already listed. Nothing herein shall be construed as legal, accounting or other professional advice outside the realm of real estate brokerage.",

  // Contact card
  "card.title": "Do you have questions?",
  "card.body": "Call or text today, we are here to help!",
  "card.consent":
    "I agree to be contacted by Zaga Team via text, call & email. To opt-out, reply 'stop' or click unsubscribe.",
};

const es: Dict = {
  "banner.construction": "AHORA EN CONSTRUCCIÓN",
  "banner.starting": "RESIDENCIAS DESDE $4M",
  "banner.sold": "75% VENDIDO",

  "nav.north": "Torre Norte",
  "nav.south": "Torre Sur",
  "nav.floorplans": "Planos",
  "nav.gallery": "Galería",
  "nav.location": "Ubicación",
  "nav.request": "Solicitar Información",

  "hero.eyebrow": "Brickell Key · Miami",
  "hero.schedule": "Agendar Presentación",
  "hero.requestPriceList": "Solicitar Lista de Precios",
  "hero.scroll": "Deslizar",

  "intro.eyebrow": "500 Brickell Key Drive",
  "intro.title": "Una dirección isleña, a minutos del corazón de Miami.",
  "intro.body":
    "Ubicado en la punta sur de Brickell Key, The Residences at Mandarin Oriental, Miami se compone de dos torres arquitectónicas conectadas por jardines exuberantes, un puerto deportivo privado y un hotel de servicio completo. Un santuario de calma, un escenario para la ciudad.",

  "condos.title": "CONDOS EN VENTA",
  "condos.address": "888 Brickell Ave, Miami, FL 33131",
  "condos.beds": "Hab.",
  "condos.baths": "Baño(s)",
  "condos.prev": "Anterior",
  "condos.next": "Siguiente",


  "north.eyebrow": "Torre Norte",
  "north.title": "Vida isleña elevada, reimaginada.",
  "north.body":
    "Elevándose 33 pisos sobre la punta más al sur de Brickell Key, la Torre Norte presenta una colección exclusiva de solo 70 Residencias Privadas junto al nuevo Hotel Mandarin Oriental, Miami. Vistas panorámicas de Biscayne Bay, el Océano Atlántico y el skyline de Miami se complementan con amenidades de clase mundial, el legendario servicio Mandarin Oriental y un estilo de vida frente al mar excepcional.",
  "north.stat.stories": "Pisos",
  "north.stat.residences": "Residencias Privadas",
  "north.stat.starting": "Desde",

  "south.eyebrow": "Torre Sur",
  "south.title": "Lujo icónico frente al mar, elevado.",
  "south.body":
    "Elevándose 66 pisos sobre la punta más al sur de Brickell Key, la Torre Sur es un ícono arquitectónico con 228 residencias de lujo. Diseñada por Kohn Pedersen Fox (KPF) con interiores de Tristan Auer, cada residencia ofrece amplios ventanales de piso a techo, terrazas privadas de 12 pies de profundidad, pisos de piedra natural, gabinetes italianos a medida y techos de 11 pies. Combinado con el legendario servicio Mandarin Oriental, amenidades de clase mundial y vistas impresionantes de Biscayne Bay y el skyline de Miami, la Torre Sur ofrece un estilo de vida frente al mar sin igual.",
  "south.stat.stories": "Pisos",
  "south.stat.residences": "Residencias de Lujo",
  "south.stat.starting": "Desde",

  "downloads.eyebrow": "Entrega 2030",
  "downloads.title1": "Desde",
  "downloads.title2": "$4 Millones",
  "downloads.brochure": "Descargar Brochure",
  "downloads.factSheet": "Descargar Ficha Técnica",
  "downloads.floorPlans": "Descargar Planos",
  "downloads.renderings": "Descargar Renders",

  "location.eyebrow": "Ubicación",
  "location.title": "500 Brickell Key Drive, Miami.",
  "location.body":
    "A seis minutos en auto del Distrito Financiero. Doce minutos del Aeropuerto Internacional de Miami. A una vida de distancia de todo lo demás.",

  "gallery.eyebrow": "GALERÍA",
  "gallery.title": "Galería Mandarin",

  "contact.eyebrow": "Consultar",
  "contact.title": "Solicita la lista privada de precios.",
  "contact.body":
    "Completa el formulario y un miembro de nuestro equipo de ventas se pondrá en contacto contigo dentro de un día hábil.",

  "modal.title": "Solicitar Información",
  "modal.subtitle": "Completa el formulario y nos pondremos en contacto contigo pronto.",
  "modal.rolePlaceholder": "¿Eres comprador o agente inmobiliario? *",
  "modal.buyer": "Comprador",
  "modal.agent": "Agente inmobiliario",
  "modal.firstName": "Nombre *",
  "modal.lastName": "Apellido *",
  "modal.email": "Correo electrónico *",
  "modal.phone": "Número de teléfono *",
  "modal.comments": "Comentarios",
  "modal.timeframe": "Tiempo estimado de compra",
  "modal.timeframe.placeholder": "Tiempo estimado de compra",
  "modal.timeframe.1": "Dentro de 1 mes",
  "modal.timeframe.2": "De 2-3 meses",
  "modal.timeframe.3": "De 3-6 meses",
  "modal.timeframe.4": "De 6 meses a +",

  "modal.consent":
    "Autorizo a ser contactado por Zaga Team | Mandarin Oriental Miami vía llamada, correo o mensaje para servicios inmobiliarios. Puedes darte de baja en cualquier momento respondiendo 'stop' o 'help' para asistencia. También puedes hacer clic en el enlace para darte de baja en los correos. Pueden aplicar tarifas estándar de mensajes y datos. La frecuencia de los mensajes puede variar. Política de Privacidad y Términos de Servicio.",
  "modal.required": "* Campos requeridos",
  "modal.submit": "Enviar",
  "modal.thankYou": "Gracias",
  "modal.thankYouBody": "Nos pondremos en contacto contigo pronto.",
  "modal.close": "Cerrar",

  "agent.notice": "Aviso",
  "agent.title": "Solo Compradores",
  "agent.body1":
    "Lamentablemente, no trabajamos con agentes inmobiliarios. Sin embargo, si tienes una consulta específica, no dudes en llamarnos al ",
  "agent.close": "Cerrar",

  "footer.eyebrow": "Consultar",
  "footer.title": "Solicita Precios y Disponibilidad",
  "footer.body":
    "Para información detallada, precios y disponibilidad, completa el formulario; nuestro equipo te contactará con la información más reciente de este desarrollo.",
  "footer.deposit": "Plan de Depósitos",
  "footer.deposit1": "20% al Contrato",
  "footer.deposit2": "20% al Inicio de Obra",
  "footer.deposit3": "10% al Deck de Amenidades",
  "footer.deposit4": "50% al Cierre",
  "footer.salesAddress": "Dirección de la Galería de Ventas",
  "footer.contactInfo": "Información de Contacto",
  "footer.rolePlaceholder": "¿Eres comprador o agente inmobiliario? *",
  "footer.agent": "Agente Inmobiliario",
  "footer.commentsPlaceholder": "Estoy interesado en The Residences at Mandarin Oriental, Miami",
  "footer.consent":
    "Acepto ser contactado por Zaga Team | Mandarin Oriental Miami vía llamada, correo y mensaje para servicios inmobiliarios. Responde 'stop' para darte de baja.",
  "footer.required": "* Campos requeridos",
  "footer.submit": "SOLICITAR INFORMACIÓN",
  "footer.legal":
    "Zaga team es un equipo de asesoría inmobiliaria afiliado a Luxury International Realty LLC. Luxury International Realty LLC es un corredor de bienes raíces con licencia y cumple con las leyes de igualdad de vivienda. Todo el material presentado aquí tiene fines meramente informativos. La información se compila de fuentes consideradas confiables, pero está sujeta a errores, omisiones, cambios de precio, condición, venta o retiro sin previo aviso. No se hace ninguna declaración sobre la exactitud de ninguna descripción. Todas las medidas y metrajes son aproximados. Esto no busca solicitar propiedades ya listadas. Nada de lo aquí expuesto debe interpretarse como asesoría legal, contable u otra asesoría profesional fuera del ámbito del corretaje inmobiliario.",

  "card.title": "¿Tienes preguntas?",
  "card.body": "Llama o escribe hoy, estamos aquí para ayudarte!",
  "card.consent":
    "Acepto ser contactado por Zaga Team vía mensaje, llamada y correo. Para darte de baja, responde 'stop' o haz clic en 'unsubscribe'.",
};

const dicts: Record<Lang, Dict> = { en, es };

const LangCtx = createContext<{ lang: Lang; setLang: (l: Lang) => void; t: (k: string) => string }>({
  lang: "en",
  setLang: () => {},
  t: (k) => k,
});

export function LangProvider({ children }: { children: ReactNode }) {
  const [lang, setLangState] = useState<Lang>("en");

  useEffect(() => {
    try {
      const saved = window.localStorage.getItem("lang") as Lang | null;
      if (saved === "en" || saved === "es") setLangState(saved);
    } catch {}
  }, []);

  const setLang = (l: Lang) => {
    setLangState(l);
    try {
      window.localStorage.setItem("lang", l);
    } catch {}
  };

  const t = (key: string) => dicts[lang][key] ?? dicts.en[key] ?? key;

  return <LangCtx.Provider value={{ lang, setLang, t }}>{children}</LangCtx.Provider>;
}

export const useLang = () => useContext(LangCtx);
